import httpManager from "@/app/shared/utils/httpManager";
/**
 * Descargar un excel con los tickets.
 *
 * @return {Promise} Excel
 */
export async function downloadTicketsWithBasicFilters(params) {
  const { entity, portfolio, channel, startDate, endDate } = params;

  let url = `/tickets/manager/download-excel/?channel=${channel}&start_date=${startDate}&end_date=${endDate}&`;

  if (entity) url += `entity=${entity ?? ""}&`;
  if (portfolio) url += `portfolio=${portfolio}&`;

  const response = await httpManager.getBlob(url);
  return response;
}

export async function downloadTicketsWithAdvancedFilters(params) {
  const {
    entity,
    portfolio,
    channel,
    queues,
    ticketStates,
    tags,
    users,
    startDate,
    endDate,
    contact_types,
  } = params;

  const base = {
    entity_id: entity || undefined,
    portfolio_id: portfolio || undefined,
    queues_id: queues,
    states_id: ticketStates,
    tags_id: tags,
    users_id: users,
    groups: contact_types,
    start_date: startDate,
    end_date: endDate,
  };

  let filters = {};

  if (!channel) {
    filters = base;
  } else {
    filters = { ...base, channel };
  }

  const response = await httpManager.post(`/tickets/manager/download-excel/`, filters, {
    blob: true,
  });

  return response;
}
